module.exports = __webpack_public_path__ + "img/therapist.0ceef6fe.svg";